import React from 'react';
import { useDispatch } from 'react-redux';
import { addToCart } from '../../store/reducers/cartReducer';
import { addNotification } from '../../store/reducers/uiReducer';

export const ProductCard = ({ product }) => {
    const dispatch = useDispatch();
    const dollarUSLocale = Intl.NumberFormat('en-US');

    const handleAddToCart = () => {
        dispatch(
            addToCart({
                product,
                quantity: 1
            })
        );
        dispatch(
            addNotification({
                title: 'Cart',
                type: 'primary',
                icon: 'shopping-cart',
                message: `${product.name} added`
            })
        );
    };

    return (
        <div className="card">
            <div className="card-body">
                <div className="text-center text-secondary mb-2">
                    <i className={`fad fa-${product.icon} fa-5x`}></i>
                </div>
                <h5 className="card-title text-center">{product.name}</h5>
                <h4 className="h5 text-success text-center">
                    ${dollarUSLocale.format(product.price)}.00
                </h4>
                <p className="card-text product-description">{product.description}</p>
                <div className="d-grid gap-2">
                    <button
                        type="button"
                        className="btn btn-outline-primary"
                        onClick={handleAddToCart}>
                        Add to cart
                    </button>
                </div>
            </div>
        </div>
    );
};
